var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{on:{"click":function($event){$event.preventDefault();return _vm.closeSurvey.apply(null, arguments)}}},[_c('Icon',{staticClass:"close-icon",attrs:{"name":"xmark","art":"light"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }